export type OptionSearchBarSelectStatus = {
  id: number;
  status: number;
  name: string;
  checked: boolean;
  color: "blue" | "green" | "yellow" | "red" | "grey";
};

export type ActiveOptionsStatus = Array<number>;
export type OptionsStatusList = OptionSearchBarSelectStatus[];

export type ActiveOptionsStatusProperty = (
  options: OptionsStatusList
) => ActiveOptionsStatus;

export const getActiveOptionsStatus: ActiveOptionsStatusProperty = (
  options
) => {
  return options.reduce(
    (acc: ActiveOptionsStatus, option: OptionSearchBarSelectStatus) => {
      if (option.checked) {
        acc.push(option.status);
      }
      return acc;
    },
    []
  ) as ActiveOptionsStatus;
};
